import React from "react";
import { BrowserRouter as Router, Route, withRouter } from "react-router-dom";
import './App.css';

import Header from './components/header.js';
import Home from './components/home.js';
import About from './components/about.js';
import Partners from './components/partners.js';
import Companies from './components/companies.js';
import Faq from './components/faq.js';


class ScrollToTopWithoutRouter extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

const ScrollToTop = withRouter(ScrollToTopWithoutRouter)


class App extends React.Component {
    render() {
        return (
            <Router>
                <ScrollToTop>
                    <div id="app" className="App">
                        <Header />
                        <div className="App-body">
                            <Route exact path="/" component={Home} />
                            <Route path="/about" component={About} />
                            <Route path="/partners" component={Partners} />
                            <Route path="/companies" component={Companies} />
                            <Route path="/faq" component={Faq} />
                        </div>
                    </div>
                </ScrollToTop>
            </Router>
        )
    };
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js